import { AuthGuard } from '../../../shared/services';
import { SeekersListComponent } from './seekers-list.component';
import { Route } from '@angular/router';

export const SeekersListeRoutes: Route[] = [
  {
    path: 'list',
    component: SeekersListComponent,
    canActivate: [AuthGuard]
  }
];
